import React, { ReactElement } from 'react';
import type { Route } from 'next';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import proxyAxios from 'api/proxyAxios';
import { endpoints } from 'api/endpoints';
import { TopArticlesCardType } from 'sections/Home/types';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import { LeadFormParameters } from 'components/LeadForm/LeadForm.data';
import Breadcrumbs from 'components/Breadcrumbs';
import 'swiper/css';
import styles from 'pages/resources/freight-templates/bill-of-lading/BillOfLading.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Resources/FreightTemplates/BillOfLading/components/SectionHeader/'));
const SectionAbout = dynamic(() => import('sections/Resources/FreightTemplates/BillOfLading/components/SectionAbout/'));
const SectionPurpose = dynamic(() => import('sections/Resources/FreightTemplates/BillOfLading/components/SectionPurpose/'));
const SectionDocuments = dynamic(() => import('sections/Resources/FreightTemplates/BillOfLading/components/SectionDocuments/'));
const SectionFaq = dynamic(() => import('sections/Resources/FreightTemplates/BillOfLading/components/SectionFaq/'));
const SectionCallToAction = dynamic(() => import('sections/Resources/FreightTemplates/BillOfLading/components/SectionCallToAction'));
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// const SectionForm = dynamic(() => import('sections/Resources/FreightTemplates/BillOfLading/components/SectionForm/'));
const SectionRelatedPosts = dynamic(() => import('sections/Resources/FreightTemplates/BillOfLading/components/SectionRelatedPosts/'));

interface BillOfLadingProps {
  articles: TopArticlesCardType[];
  pageTitle?: string;
  formUrl?: string;
  leadSubtype?: string;
}

export default function BillOfLading({ articles, pageTitle, formUrl, leadSubtype }: BillOfLadingProps) {
  return (
    <div className={cn('bill-of-lading')}>
      <div className={cn('container')}>
        <Breadcrumbs
          mTop={64}
          mode="light"
          links={[
            { title: 'Freight Templates', href: '/resources/freight-templates' as Route },
            { title: 'Bill of Lading Forms and Templates', href: '' as Route },
          ]}
        />
      </div>
      <SectionHeader />
      <SectionAbout />
      <SectionPurpose />
      <SectionDocuments />
      <SectionFaq />
      <SectionCallToAction />
      {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
      {/* <SectionForm
        pageTitle={pageTitle}
        formUrl={formUrl}
        leadSubtype={leadSubtype}
      /> */}
      <SectionRelatedPosts articles={articles} />
    </div>
  );
}

export const getStaticProps = async () => {
  const meta = {
    title: 'Bill of Lading Template Free Download | DF Alliance',
    description: 'Download a free bill of lading template from DF Alliance to record shipment details accurately.',
    path: '/resources/freight-templates/bill-of-lading',
  };

  // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
  // 'FormParameters' - parameters, passed to 'Form' component in 'SectionForm' on all Benefits pages as additional data for CRM: 
  // const FormParameters = {
  //   pageTitle: LeadFormParameters.BillOfLadingFormsAndTemplates.pageTitle,
  //   formUrl: LeadFormParameters.BillOfLadingFormsAndTemplates.formUrl,
  //   leadSubtype: LeadFormParameters.BillOfLadingFormsAndTemplates.leadSubtype,
  // };

  try {
    const { data: articles } = await proxyAxios(endpoints.blog.previewArticles + '?limit=3');

    return { props: { 
      articles, 
      ...meta, 
      // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
      // ...FormParameters, 
    } };
  } catch (e) {
    console.log('endpoints.blog.previewArticles', e);
  }

  return {
    props: {
      articles: [],
      ...meta,
      // (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
      // ...FormParameters,
    },
  };
};

BillOfLading.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
